import { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const TYPES = ["distributor", "salon", "retail", "pharmacy", "hotel", "online", "other"];
const VOLUMES = ["v1", "v2", "v3", "v4"];
const BRANDS = ["primus", "bellecare", "both", "other", "private"];
const EMPTY = { name: "", company: "", email: "", phone: "", country: "", business_type: "", volume: "", brand: "", message: "", website: "" };
const input = "w-full h-12 bg-[#0b0a08] border border-white/15 px-4 text-sm text-white focus:outline-none focus:border-[#c9a55c] transition-colors";

export const PartnerForm = () => {
  const { t } = useI18n();
  const [f, setF] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try { await axios.post(`${API}/partner-inquiries`, f); setState("sent"); }
    catch (x) { setState(JSON.stringify(x?.response?.data?.detail || "").includes("email") ? "bad-email" : "error"); }
  };
  if (state === "sent") return <p data-testid="partner-form-success" className="font-display text-2xl text-gold py-10">{t("partner_sent")}</p>;
  const field = (k, type = "text", required = false) => (
    <input data-testid={`partner-${k}-input`} type={type} required={required} value={f[k]} onChange={set(k)} placeholder={t(`partner_${k}`) + (required ? " *" : "")} className={input} />
  );
  const select = (k, opts, required = false) => (
    <select data-testid={`partner-${k}-select`} required={required} value={f[k]} onChange={set(k)} className={`${input} ${f[k] ? "" : "text-white/45"}`}>
      <option value="">{t(`partner_${k}`) + (required ? " *" : "")}</option>
      {opts.map((o) => <option key={o} value={o}>{t(`partner_${k}_${o}`)}</option>)}
    </select>
  );
  return (
    <form data-testid="partner-form" onSubmit={submit} className="grid sm:grid-cols-2 gap-3">
      {field("name", "text", true)}{field("company")}{field("email", "email", true)}{field("phone", "tel")}
      {field("country")}{select("business_type", TYPES, true)}{select("volume", VOLUMES)}{select("brand", BRANDS)}
      <textarea data-testid="partner-message-input" required minLength={5} rows={5} value={f.message} onChange={set("message")}
        placeholder={`${t("partner_message")} *`} className={`${input} sm:col-span-2 h-auto py-3 resize-none`} />
      <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" value={f.website} onChange={set("website")} className="hidden" />
      {state === "error" && <p data-testid="partner-form-error" className="text-xs text-red-400 sm:col-span-2">{t("partner_error")}</p>}
      {state === "bad-email" && <p data-testid="partner-form-email-error" className="text-xs text-red-400 sm:col-span-2">{t("partner_bad_email")}</p>}
      <button data-testid="partner-submit-button" disabled={state === "sending"} className="btn-gold btn-shine h-14 sm:col-span-2 disabled:opacity-60">{t("partner_send")}</button>
    </form>
  );
};
